
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * TranslatableTabs
 *
 * Renders language tabs for translatable fields. Shows a red alert listing
 * which fields are missing or invalid so the user gets a clear explanation,
 * even if the problem is on a tab they are not currently viewing.
 *
 * Usage:
 *   <TranslatableTabs
 *     :languages="languages"
 *     :defaultLanguage="defaultLanguage"
 *     :invalidFields="invalidFields"
 *   >
 *     <template v-slot="{ lang, isDefault }">
 *       <v-text-field
 *         v-model="form.name[lang]"
 *         :rules="isDefault ? [(v: string) => !!v || $t('common.required')] : []"
 *         ...
 *       />
 *     </template>
 *   </TranslatableTabs>
 *
 * invalidFields is a string[] of human-readable field labels that are invalid.
 * Compute it in the parent based on required fields, e.g.:
 *   get invalidFields(): string[] {
 *     const fields: string[] = [];
 *     if (!this.form.name[this.defaultLanguage]) {
 *       fields.push(`${this.$t('common.name')} (${this.defaultLanguage})`);
 *     }
 *     return fields;
 *   }
 */
@Component
export default class TranslatableTabs extends Vue {
  @Prop({ default: () => [] })
  protected languages!: string[]

  @Prop({ default: '' })
  protected defaultLanguage!: string

  @Prop({ default: () => [] })
  protected invalidFields!: string[]

  protected activeTab: any = null
}
